export default {
    bulk_add_driver_tag_title: "Add DriverID Tags",
    bulk_add_driver_tag_account: "Account",
    bulk_add_driver_tag_id: "ID#",
    bulk_add_driver_tag_model: "Model",
    bulk_add_driver_tag_message: "Message",
    bulk_add_driver_tag_repeated_in_list: "Some repeated  tag ids were no added to the list",
    bulk_add_driver_tag_already_in_use: "This ID# is already in-use and will not be imported",
    bulk_add_driver_tag_is_necessary_to_select_an_account: "It is necessary to select an account",
    bulk_add_driver_tag_ready_to_import: "Ready to import",
    bulk_add_driver_tag_import_message: "DriverID tag(s) imported",
}